/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum FullscreenSources {
    IGO = 'igo',
    Streaming = 'streaming',
    ClientIME = 'ime',
    PrivacyPolicy = 'privacy',
    QuitGath = 'quitGame',
    OscNotification = 'OscNotification'
}

export enum DocumentVisibilityState {
    Visible = 'visible',
    Hidden = 'hidden'
}

export enum HostNames {
    Local = 'localhost',
    Stage = 'stage.nvidia.com',
    Partner = 'partner.nvidia.com'
}

export type BrowserPermissionName = 'clipboard-read' | 'microphone' | 'notifications';

export const RegxReducePathnameToBranch = new RegExp('/mall/index[.]html$|/mall/$|/index[.]html$|/$');

export const transparentImgHref = './assets/img/transparent.png';
